import React from 'react';

export default ({ handleSortClick, order, sortedBy }) => {
  function createClasses(key) {
    if (sortedBy === key) return `${order ? 'asc' : 'desc'} active`;
    return '';
  }

  return (
    <div className='list-scene__table-header'>
      <div
        className={`list-scene__table-header-element ${createClasses('inspectionDate')} _width_pc_12`}
        onClick={handleSortClick('inspectionDate')}
      >
        <div>Inspection Date</div>
        <div className='list-scene__table-header-element-sort-arrow' />
      </div>

      <div
        className={`list-scene__table-header-element ${createClasses('user')} _width_pc_14`}
        onClick={handleSortClick('user')}
      >
        <div>Inspector Name</div>
        <div className='list-scene__table-header-element-sort-arrow' />
      </div>

      <div
        className={`list-scene__table-header-element ${createClasses('location')} _width_pc_14`}
        onClick={handleSortClick('location')}
      >
        <div>Inspection Address</div>
        <div className='list-scene__table-header-element-sort-arrow' />
      </div>

      <div
        className={`list-scene__table-header-element ${createClasses('year')} _width_pc_8`}
        onClick={handleSortClick('year')}
      >
        <div>Model Year</div>
        <div className='list-scene__table-header-element-sort-arrow' />
      </div>

      <div
        className={`list-scene__table-header-element ${createClasses(
          'description'
        )} list-scene__table-row-element_place_filler`}
        onClick={handleSortClick('description')}
      >
        <div>Description</div>
        <div className='list-scene__table-header-element-sort-arrow' />
      </div>

      <div
        className={`list-scene__table-header-element ${createClasses('status')} _width_pc_18`}
        onClick={handleSortClick('status')}
      >
        <div>Inspection Status</div>
        <div className='list-scene__table-header-element-sort-arrow' />
      </div>

      <div className='list-scene__table-header-element _width_pc_12' />
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/app/Scenes/Inspection/List/TableHeader.jsx